import Vue from 'vue'
import {chartColors} from '@/helpers/color-helper'

const $ = kendo.jQuery
const ee = new Vue()

function getName(e) {
  const selectedGroup = e.group.items.filter(element => (element.value = e.group.value))[0]
  const label = selectedGroup != null ? selectedGroup.seriesLabel || 'N/A' : 'N/A'
  return label
}

function createChart($container, options, renderLocation) {
  return new Promise(function(resolve, reject) {
    const actionName = options.nbMonths == null ? 'getChartDataSource' : 'getChartDataSource1'
    const dataInstruments = JSON.stringify(options.dataInstruments)
    const dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: `/api/report/marketData/${actionName}`,
          cache: false,
          type: 'GET',
          data:
            options.nbMonths == null
              ? {
                  fromDate: options.fromDate,
                  toDate: options.toDate,
                  marketId: options.marketId,
                  dataInstruments,
                }
              : {
                  asOfDate: options.asOfDate,
                  nbMonths: options.nbMonths,
                  marketId: options.marketId,
                  dataInstruments,
                },
          dataType: 'json',
        },
      },
      schema: {
        parse: function(response) {
          chart.options.title.text = renderLocation == 'pdf' ? ' ' : response.title
          chart.options.valueAxis.min = response.minAxis
          chart.options.categoryAxis.labels.step = response.labelsStep
          return response
        },
        data: 'data',
        model: {
          fields: {
            dataInstrumentId: {
              type: 'number',
            },
            seriesLabel: {
              type: 'string',
            },
            evaluationDate: {
              type: 'date',
            },
            dataValue: {
              field: 'value',
              type: 'number',
            },
          },
        },
      },
      group: {
        field: 'dataInstrumentId',
      },
      sort: {
        field: 'evaluationDate',
        dir: 'asc',
      },
      requestEnd: () => {
        chart.options.legend.visible = true
        chart.refresh()
      },
      error: err => reject(err),
    })

    const chart = $container
      .kendoChart({
        render: () => {
          resolve(chart)
          ee.$emit('render')
        },
        dataSource: dataSource,
        title: {
          padding: {
            bottom: 5,
          },
        },
        legend: {
          position: 'bottom',
          visible: false,
        },
        seriesDefaults: {
          type: 'line',
          markers: {
            size: 3,
            visible: true,
          },
        },
        seriesColors: chartColors(),
        series: [
          {
            field: 'dataValue',
            name: e => getName(e),
            labels: {
              visible: false,
            },
          },
        ],
        valueAxis: [
          {
            title: {
              font: '10px',
            },
            labels: {
              format: options.marketId == 2 ? '{0:P4}' : '{0:N4}',
              font: '10px Arial',
            },
            name: 'K',
          },
        ],
        categoryAxis: {
          field: 'evaluationDate',
          baseUnit: 'months',
          labels: {
            visible: true,
            rotation: -45,
            font: '10px Arial',
            margin: {
              top: 16,
            },
            template: e => {
              const date = e.dataItem && e.dataItem.evaluationDate
              return kendo.toString(date || '', 'yyyy-MM-dd')
            },
          },
          majorGridLines: {
            visible: false,
          },
        },
        tooltip: {
          visible: true,
          template:
            options.marketId == 2
              ? "#=kendo.format('{0:P4}', value)#"
              : "#=kendo.format('{0:N5}', value)#",
        },
      })
      .data('kendoChart')
  })
}

function renderChart($container, options, renderLocation) {
  $container.empty()

  if (renderLocation == null) renderLocation = 'pdf'

  const $chartContainer = $('<div></div>').appendTo($container)
  return createChart($chartContainer, options, renderLocation)
}

export default {
  openChart: function(options) {
    const $window = $("<div class='exposureChartWindow'></div>")
      .empty()
      .appendTo(document.body)
    var kendoWindow = $window
      .kendoWindow({
        visible: false,
        modal: true,
        width: '832px',
        height: '432px',
        resizable: false,
        actions: ['Close'],
        close: function() {
          this.destroy()
        },
      })
      .getKendoWindow()

    const renderLocation = 'page'
    const $chart = $('<div></div>').appendTo($window.empty())
    kendoWindow.setOptions({
      title: 'Loading...',
    })
    kendoWindow.center().open()

    createChart($chart, options, renderLocation).then(function(mdChart) {
      kendoWindow.setOptions({
        title: 'Market Data Chart',
      })
      mdChart.resize()
    })
  },
  render: function($container, options, renderLocation) {
    return renderChart($container, options, renderLocation).then(function(mdChart) {
      mdChart.resize()
    })
  },
  onRender: function(callback) {
    ee.$on('render', callback)
  },
}
